export function isNoindexRobots(robots: string): boolean {
  return robots.toLowerCase().includes('noindex');
}
